// TODO Migrate away from deprecated execCommand
const copyToClipBoard = (text: string) => {
  const copyId = 'copy_id';
  const node = document.createElement('textarea');

  document.body.appendChild(node);

  node.setAttribute('id', copyId);

  document.getElementById(copyId).value = text;

  node.select();

  document.execCommand('copy');

  document.body.removeChild(node);
};

export default copyToClipBoard;
